/* eslint-disable eqeqeq */
import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  API,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { formatName } from "../../../lib/Misc";
import {
  CheckCircle2,
  Clock,
  LucideMessageSquareShare,
  Verified,
  VerifiedIcon,
} from "lucide-react";
import { Button } from "../../../components/ui/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomTooltip from "../../../components/CustomTooltip";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import Confirmation from "../../../components/Confirmation";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { PhoneInput } from "../../../components/ui/phone-input";
import { Checkbox } from "../../../components/ui/checkbox";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import VerifyModal from "./VerifyModal";
import EscalatedModal from "./EscalatedModal";
import CDDVerifyCheck from "../../../components/Assessment_KYC/CDDVerifyCheck";
import BiometricsStatus from "./BiometricsStatus";

const ExpandCDD = ({
  expandData,
  simplified,
  kyc,
  setLoading,
  sectionType,
  fetchCDDs,
}) => {
  const [confirmVerify, setConfirmVerify] = useState(false);
  const [cddId, setCddId] = useState("");
  const [cddItem, setCddItem] = useState("");

  const [mobile, setMobile] = useState();
  const [consent, setConsent] = useState();

  const [showVisual, setShowVisual] = useState(false);

  const toggleConfirmVerify = (id, data) => {
    if (confirmVerify) {
      setCddId();
      setCddItem();
      setMobile();
      setConsent();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmVerify(!confirmVerify);
  };

  const toggleVisual = (id, data) => {
    if (showVisual) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowVisual(!showVisual);
  };

  const [confirmEscalated, setConfirmEscalated] = useState(false);

  const toggleConfirmEscalated = (id, data) => {
    if (confirmEscalated) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmEscalated(!confirmEscalated);
  };

  const expandDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      let data = {
        key: expandData[i]?.id,
        verification_document_type: expandData[i]?.verification_document_type
          ?.label
          ? expandData[i]?.verification_document_type?.label
          : "",
        date_verified: expandData[i]?.date_verified
          ? expandData[i]?.date_verified
          : "",
        verified_by: expandData[i]?.verified_by
          ? formatName(
              expandData[i]?.verified_by?.first_name,
              expandData[i]?.verified_by?.last_name,
            )
          : "",
        biometrics: expandData[i]?.["bdv_results"]?.["bdv_results"] ? (
          <BiometricsStatus
            results={expandData[i]?.["bdv_results"]?.["bdv_results"]}
          />
        ) : (
          ""
        ),
        method: expandData[i]?.method_title ? expandData[i]?.method_title : "",
        verified_status: expandData[i]?.verified ? (
          <VerifiedIcon size={18} className="text-green-500" />
        ) : (
          ""
        ),
      };

      data.action = (
        <>
          {expandData[i]?.verified === 1 ? (
            <Button
              size={"sm"}
              className="bg-green-500 hover:bg-green-600 text-white h-6 px-2"
            >
              <div className="flex items-center gap-1">
                <CheckCircle2 size={14} />
                <span>Verified</span>
              </div>
            </Button>
          ) : expandData[i]?.verified === 2 ? (
            <span className="flex items-center gap-2 justify-center">
              <Button
                size={"sm"}
                className="bg-yellow-500 hover:bg-yellow-600 text-white h-6 px-2"
              >
                <div className="flex items-center gap-1">
                  <Clock size={14} />
                  <span>Pending</span>
                </div>
              </Button>
              <CDDVerifyCheck
                listData={kyc}
                setCddId={setCddId}
                setLoading={setLoading}
                cddId={cddId}
                fecthData={fetchCDDs}
              />
            </span>
          ) : (
            <span className="flex items-center gap-2 justify-center">
              {expandData[i]?.method !== 1 ? (
                kyc?.cdd === "1" ? (
                  <span className="flex items-center gap-2 justify-center">
                    <CustomTooltip message={"Escalate"}>
                      <span>
                        <LucideMessageSquareShare
                          size={18}
                          onClick={() => {
                            toggleConfirmEscalated(kyc?.id, kyc);
                          }}
                        />
                      </span>
                    </CustomTooltip>
                  </span>
                ) : (
                  <Button
                    onClick={() => {
                      toggleConfirmVerify(kyc?.id, kyc);
                    }}
                    size={"sm"}
                    className="h-6 px-2"
                  >
                    <div className="flex items-center gap-1">
                      <Verified size={14} />
                      <span>Verify</span>
                    </div>
                  </Button>
                )
              ) : (
                <span className="flex items-center gap-2 justify-center">
                  {kyc?.cdd === "1" && (
                    <>
                      <CustomTooltip message={"Escalate"}>
                        <span>
                          <LucideMessageSquareShare
                            size={18}
                            onClick={() => {
                              toggleConfirmEscalated(kyc?.id, kyc);
                            }}
                          />
                        </span>
                      </CustomTooltip>
                      <span>/</span>
                    </>
                  )}
                  <CustomTooltip message={"Edit"}>
                    <span>
                      <FontAwesomeIcon
                        icon={faEdit}
                        size="1x"
                        onClick={() => {
                          toggleVisual(kyc?.id, expandData[i]);
                        }}
                      />
                    </span>
                  </CustomTooltip>
                </span>
              )}
            </span>
          )}
        </>
      );

      items.push(data);
    }
    return items;
  };

  const subExapndData = expandDataGenerator(expandData?.length);

  let columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "verification_document_type",
      text: "Document Type",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "date_verified",
      text: "Date Verified",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "verified_by",
      text: "Verified By",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "method",
      text: "Method",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "biometrics",
      text: "Biometrics",
    },

    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "verified_status",
    //   text: "Verified",
    // },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  const handleVerifyID = async () => {
    try {
      setLoading(true);
      await get(
        `${API.GET_CDD_VERFIY}/${cddId}?cdd=0&cdd_customer_type=${sectionType}&mobile=${mobile}&method=${cddItem?.method}`,
      );
      setLoading(false);
      fetchCDDs();
    } catch (error) {
      setLoading(false);
      fetchCDDs();
    }
  };

  return (
    <>
      <div className="custom-table p-2">
        <div className={"table-body-class"}>
          <BootstrapTable
            keyField="key"
            remote
            data={subExapndData}
            columns={columns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>

        <Confirmation
          title={"Verify Data"}
          open={confirmVerify}
          setOpen={setConfirmVerify}
          toggleShow={() => {
            toggleConfirmVerify();
          }}
          className="sm:max-w-1/2"
          message={
            <>
              <div>Are you sure you want to verify the record?</div>
              <div className="grid grid-cols-1 text-left mt-2">
                <div className="grid gap-2">
                  <Label htmlFor="phone">
                    <CustomLabelText
                      required={cddItem?.method === 2 ? true : false}
                      labelText="Mobile No."
                      errorField={""}
                    />
                  </Label>
                  <PhoneInput
                    onChange={(e) => {
                      setMobile(e);
                    }}
                    value={mobile}
                    defaultValue={"+61"}
                    defaultCountry={"AU"}
                    minLength={15}
                    maxLength={15}
                  />
                </div>
                <div className="flex items-start space-x-2 mt-4">
                  <Checkbox
                    id="terms"
                    checked={consent}
                    name="same_address"
                    onClick={() => {
                      setConsent(!consent);
                    }}
                  />
                  <label
                    htmlFor="terms"
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-justify"
                  >
                    I confirm that I am authorised to conduct this identity
                    check and I consent to information being checked with the
                    document issuer or official record holder via third party
                    systems for the purpose of confirming customer identity.
                    Would you like Myna Australia Pty Ltd to verify the id now?
                  </label>
                </div>
              </div>
            </>
          }
          disabled={cddItem?.method === 2 ? !mobile && !consent : !consent}
          okAction={async () => {
            handleVerifyID();
            toggleConfirmVerify();
          }}
          cancelAction={() => {
            setCddId(null);
            setConfirmVerify(!confirmVerify);
          }}
        />

        {showVisual && (
          <ResponsiveDrawerForm
            description={""}
            title={`Visual Changes`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleVisual();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showVisual}
            buttonClassName={""}
            setOpen={setShowVisual}
            popupType={"cdds"}
          >
            <VerifyModal
              data={cddItem}
              toggleVisual={toggleVisual}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {confirmEscalated && (
          <ResponsiveDrawerForm
            description={""}
            title={`Escalated`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleConfirmEscalated();
            }}
            write={true}
            buttonText={""}
            open={confirmEscalated}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setConfirmEscalated}
            className={"sm:max-w-3xl"}
          >
            <EscalatedModal
              data={cddItem}
              toggleConfirmEscalated={toggleConfirmEscalated}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}
      </div>
    </>
  );
};

export default ExpandCDD;
